import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../contexts/AdminAuthContext';

export function AdminLayout({ children }) {
  const { admin, logout } = useAdminAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login');
  };

  return (
    <div className="min-h-screen bg-[#0A0F1E] flex">
      {/* Sidebar */}
      <div className="w-64 bg-[#0F1629] border-r border-[#1E293B] flex flex-col">
        {/* Logo */}
        <div className="p-6 border-b border-[#1E293B]">
          <h1 className="text-xl font-serif text-white">Indotravelista</h1>
          <p className="text-xs text-[#C4A962] mt-1">Admin Portal</p>
        </div>

        {/* Navigation */}
        <nav className="flex-1 p-4 space-y-1">
          <NavLink to="/admin" icon="📊">Dashboard</NavLink>
          <NavLink to="/admin/costing" icon="💰">Costing</NavLink>
          <NavLink to="/admin/projects" icon="📋">Projects</NavLink>
          <NavLink to="/admin/suppliers" icon="🏢" disabled>Suppliers</NavLink>
          <NavLink to="/admin/products" icon="📦" disabled>Products</NavLink>
          <NavLink to="/admin/b2b-requests" icon="🤝">B2B Partners</NavLink>
          <NavLink to="/admin/settings" icon="⚙️" disabled>Settings</NavLink>
        </nav>

        {/* User Info */}
        <div className="p-4 border-t border-[#1E293B]">
          <div className="text-sm text-gray-300 mb-3">
            <div className="font-medium">{admin?.full_name}</div>
            <div className="text-xs text-gray-500">{admin?.email}</div>
          </div>
          <button
            onClick={handleLogout}
            className="w-full px-4 py-2 text-sm text-gray-300 hover:text-white hover:bg-[#1E293B] rounded-lg transition-colors flex items-center justify-center gap-2"
          >
            <span>🚪</span>
            <span>Logout</span>
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 overflow-auto">
        {children}
      </div>
    </div>
  );
}

function NavLink({ to, icon, children, disabled }) {
  if (disabled) {
    return (
      <div className="px-4 py-2 text-sm text-gray-600 flex items-center gap-3 cursor-not-allowed">
        <span>{icon}</span>
        <span>{children}</span>
        <span className="ml-auto text-xs bg-[#1E293B] px-2 py-0.5 rounded">Soon</span>
      </div>
    );
  }

  return (
    <Link
      to={to}
      className="px-4 py-2 text-sm text-gray-300 hover:text-white hover:bg-[#1E293B] rounded-lg transition-colors flex items-center gap-3"
    >
      <span>{icon}</span>
      <span>{children}</span>
    </Link>
  );
}
